import { createApiService, Api, ConfigHelper, apiMixin } from 'relapp-api';
import store from '@/store/index.js';

const routes = ConfigHelper.entityApiRoutes('product');


export default {
    ...createApiService('products', 'product'),
    /**
     * Call the get all endpoint.
     *
     * @param {array} replace
     * @param {boolean} ignoreHandleError
     *
     * @return {Promise}
     */
    get(replace, ignoreHandleError) {
        let route = routes['get'];

        if (replace) {
            replace.forEach(item => {
                route = route.replace(item.key, item.value);
            });
        }

        return Api.get(route)
            .then(response => {
                let storeData = null;
                let tax = null;

                if (response.data) {
                    storeData = response.data.products;
                    tax = response.data.meta.tax;
                }

                if (storeData) {
                    store.dispatch('products/updateItems', { products: storeData, tax: tax });
                }

                return response;
            })
            .catch(err => {
                if (ignoreHandleError) {
                    return Promise.reject(err);
                }

                return apiMixin.methods.handleError(err);
            });
    },
};
